// @ts-expect-error - imported from .js/.jsx file
import {ContactAssigneeIcon} from 'shells/icon/svg/contact-assignee-icon';
import {LeadIcon} from 'shells/icon/svg/lead-icon';
import type {ListOptionWithIcon} from 'shells/select-option-components/option-with-icon';

export const NOTIFIABLE_STATIC_OPTIONS: ListOptionWithIcon[] = [
    {
        label: 'Person assignee',
        value: 'CONTACT_ASSIGNEE',
        icon: ContactAssigneeIcon,
    },
    {
        label: 'Related lead assignee',
        value: 'RELATED_LEAD_ASSIGNEE',
        icon: LeadIcon,
    },
];

export function isNotifiableAlias(value: string): boolean {
    return value === 'CONTACT_ASSIGNEE' || value === 'RELATED_LEAD_ASSIGNEE';
}
